import { render, staticRenderFns } from "./AlertCreateDoc.vue?vue&type=template&id=743860b0"
import script from "./AlertCreateDoc.vue?vue&type=script&lang=js"
export * from "./AlertCreateDoc.vue?vue&type=script&lang=js"
import style0 from "./AlertCreateDoc.vue?vue&type=style&index=0&id=743860b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports